import { render, staticRenderFns } from "./DevpromptSupport.vue?vue&type=template&id=66b32244&"
import script from "./DevpromptSupport.vue?vue&type=script&lang=js&"
export * from "./DevpromptSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports